module.exports = __webpack_public_path__ + "img/photo-42.132f4bdc.webp";